// EnergyPulse.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { TRACES } from './PCBLines';

/**
 * Renders the travelling purple energy over the PCB traces.
 *
 * The *travel* (a bright segment sliding along each path) runs continuously via
 * CSS-animated stroke-dashoffset on the compositor. The *intensity* is gated by
 * scroll: input traces fade in early (inFlow), output traces later (outFlow),
 * matching the input -> process -> output sequence.
 *
 * @param {MotionValue} inFlow   0..1 opacity for input traces
 * @param {MotionValue} outFlow  0..1 opacity for output traces
 */
function EnergyPulse({ inFlow, outFlow }) {
  return (
    <g aria-hidden="true">
      <defs>
        <linearGradient id="pulse-energy" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#6D28D9" />
          <stop offset="35%" stopColor="#7C3AED" />
          <stop offset="60%" stopColor="#8B5CF6" />
          <stop offset="82%" stopColor="#A855F7" />
          <stop offset="100%" stopColor="#C084FC" />
        </linearGradient>

        <filter id="pulse-bloom" x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="3.5" />
        </filter>
      </defs>

      {TRACES.map((t) => {
        const flow = t.kind === 'in' ? inFlow : outFlow;
        return (
          <motion.g key={t.id} style={{ opacity: flow }}>
            {/* Bloom underlay */}
            <path
              className="pcb-flow"
              d={t.d}
              fill="none"
              stroke="url(#pulse-energy)"
              strokeWidth="8"
              strokeLinecap="round"
              filter="url(#pulse-bloom)"
              pathLength={1}
              strokeDasharray="0.16 0.84"
              style={{ '--pulse-delay': `${t.delay}s` }}
            />
            {/* Hot core */}
            <path
              className="pcb-flow"
              d={t.d}
              fill="none"
              stroke="#EDE4FF"
              strokeWidth="2.4"
              strokeLinecap="round"
              pathLength={1}
              strokeDasharray="0.16 0.84"
              style={{ '--pulse-delay': `${t.delay}s` }}
            />
          </motion.g>
        );
      })}
    </g>
  );
}

export default React.memo(EnergyPulse);
